(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Give light/white colour swatches a visible border */
  const markWhiteSwatches = (root = document) => {
    const swatches = root.querySelectorAll(`
      [data-swatch],
      .swatch,
      .swatch__button,
      .swatch-input__label,
      [class*="swatch"],
      [data-option-value],
      [data-value]
    `);

    swatches.forEach((swatch) => {
      const values = [
        swatch.getAttribute('aria-label'),
        swatch.getAttribute('title'),
        swatch.getAttribute('data-value'),
        swatch.getAttribute('data-option-value'),
        swatch.getAttribute('value'),
        swatch.dataset?.value,
        swatch.textContent
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()
        .trim();

      const lightColors = [
        'white',
        'off white',
        'off-white',
        'offwhite',
        'ivory',
        'cream',
        'snow',
        'chalk',
        'natural white',
        'optic white'
      ];

      if (lightColors.some((color) => values.includes(color))) {
        swatch.classList.add('outstride-light-swatch');
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    markWhiteSwatches();

    const resultsList = document.querySelector('results-list');

    if (!resultsList) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            markWhiteSwatches(node);
          }
        });
      });
    });

    observer.observe(resultsList, {
      childList: true,
      subtree: true
    });
  });

  } catch(e) { console.error(e); }
})();
})();
